import { auth, db, storage } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';
import { ref as storageRef, listAll } from 'firebase/storage';

async function checkAuth() {
  try {
    const user = auth.currentUser;
    if (!user) return { ok: false, error: 'No authenticated user' };
    // attempt to get an ID token to ensure auth is functioning
    await user.getIdToken();
    return { ok: true };
  } catch (err) {
    return { ok: false, error: err?.message || String(err) };
  }
}

async function checkFirestore() {
  try {
    const user = auth.currentUser;
    if (!user) return { ok: false, error: 'No authenticated user' };
    const uref = doc(db, 'users', user.uid);
    await getDoc(uref);
    return { ok: true };
  } catch (err) {
    return { ok: false, error: err?.message || String(err) };
  }
}

async function checkStorage() {
  try {
    // Try listing a safe, shallow path. This may be restricted, but will indicate reachability.
    const user = auth.currentUser;
    const base = user ? `companies/${user.uid}` : 'public';
    const ref = storageRef(storage, base);
    await listAll(ref);
    return { ok: true };
  } catch (err) {
    return { ok: false, error: err?.message || String(err) };
  }
}


export async function checkServerStatus() {
  const started = Date.now();
  const results = {};
  // Run checks in parallel where possible
  const authR = await checkAuth();
  results.auth = authR;

  // Firestore and storage depend on an authenticated user for this app
  const [fsR, stR] = await Promise.all([checkFirestore(), checkStorage()]);
  results.firestore = fsR;
  results.storage = stR;

  const ok = results.auth.ok && results.firestore.ok && results.storage.ok;
  return { ok, checks: results, durationMs: Date.now() - started };
}

export default { checkServerStatus };
